module.exports = __webpack_public_path__ + "img/NIDM_Terms_Annotations_Figure1_1ff8a7b5dc7a7d1f.d4d6662d.png";